import React, { useState } from 'react';
import {
  Box,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from '@mui/material';
import clsx from 'clsx';
import TimeSince from 'components/shared/timeSince';
import { labelToDisplayLabel, labelToIconType } from 'helpers/events';
import TPFormDialog from 'components/tpForms/formModal';
import Icon from 'components/shared/icons/eventIcons';
import moment from 'moment';
import useStyles from '../leg-styles';

const SignificantReport = ({
  report,
  highlightedReportId,
  setHighlightedReportId,
  centerMapOnEvent,
  currentTime,
  setSelectedReport,
  selectedMapId
}) => {
  const classes = useStyles();
  const [openForm, setOpenForm] = useState();

  const ReportIcon = () => {
    if (report?.events[0]) {
      return (
        <ListItemIcon className={clsx(classes.iconWrapper, { [classes.selected]: highlightedReportId === report.id })}>
          {/* Fragment required because ListItemIcon only allows one child */}
          <>
            <Icon type={report.events[0]} />
            {report.form
              && (
              <Box className={classes.formBadge}>
                <Box className={classes.badgeIconWrapper}>
                  <Icon type="form" />
                </Box>
              </Box>
              )}
          </>
        </ListItemIcon>
      );
    }
    if (report?.form) {
      return (
        <ListItemIcon className={clsx(classes.iconWrapper, { [classes.selected]: highlightedReportId === report.id })}>
          <Icon type="form" />
        </ListItemIcon>
      );
    }
    return null;
  };

  return (
    <ListItem
      className={classes.listItem}
      onMouseEnter={() => {
        setSelectedReport(selectedMapId, report);
      }}
      onMouseLeave={() => {
        setSelectedReport(selectedMapId, null);
      }}
      onClick={() => {
        centerMapOnEvent(report.id);
        setSelectedReport(selectedMapId, report);
        if (highlightedReportId !== report.id) {
          setHighlightedReportId(report.id);
        } else {
          setHighlightedReportId(null);
          setSelectedReport(selectedMapId, null);
        }
      }}
    >
      <ReportIcon />
      <ListItemText className={classes.listText}>
        <Box className={classes.row}>
          <Box className={classes.reportTitle}>{report.events[0] ? labelToDisplayLabel(report.events[0]) : report.form?.title}</Box>
          <TimeSince time={moment.unix(report.received)} now={currentTime} Component={Box} className={classes.reportSince} tooltip />
        </Box>
        {report.form
          ? (
            <Box className={classes.row}>
              <Typography className={classes.formLink} onClick={() => setOpenForm(report.form)}>Form</Typography>
            </Box>
          )
          : null}
        {openForm
          ? <TPFormDialog form={openForm} onClose={() => setOpenForm(null)} />
          : null}
      </ListItemText>
    </ListItem>
  );
};

export default SignificantReport;
